import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { toMerged } from 'es-toolkit';
import { PAGE_SIZES } from '@/pages/Contacts/Contacts.utils.ts';
import { TContactsFilters, TPagination } from '@/pages/Contacts/Contacts.types';

interface IContactsState {
    filters: TContactsFilters;
    setFilters: (filters: Partial<TContactsFilters>) => void;
    resetFilters: () => void;
    dateRange?: string;
    setDateRange: (dateRange?: string) => void;
    pagination: TPagination;
    setPagination: (pagination: Partial<TPagination>) => void;
}

const initialState = {
    dateRange: undefined,
    filters: {},
    pagination: {
        per: PAGE_SIZES[0],
        page: 1
    }
};

const useContactsStore = create<IContactsState>()(
    persist(
        (set) => ({
            ...initialState,
            setDateRange: (dateRange) => {
                set({ dateRange });
            },
            setFilters: (filters) => {
                set((state) => {
                    return {
                        ...state,
                        filters: { ...state.filters, ...filters },
                        pagination: { ...state.pagination, page: 1 }
                    };
                });
            },
            resetFilters: () => {
                set((state) => {
                    return {
                        ...state,
                        dateRange: initialState.dateRange,
                        filters: initialState.filters,
                        pagination: { ...state.pagination, page: 1 }
                    };
                });
            },
            setPagination: (pagination) => {
                set((state) => ({
                    ...state,
                    pagination: { ...state.pagination, ...pagination }
                }));
            }
        }),
        {
            name: 'contacts-store',
            storage: createJSONStorage(() => globalThis.localStorage),
            // Select filters to save in localStorage
            partialize: (state) => {
                const { pagination, ...rest } = state;
                return {
                    ...rest,
                    pagination: {
                        per: pagination.per
                    }
                };
            },
            // Merge filters from localStorage with current state
            merge: (persistedState, currentState) => {
                return toMerged(currentState, persistedState as IContactsState);
            },
            version: 1.25
        }
    )
);

export default useContactsStore;
